import React from 'react';

import { useOnFirstRender } from 'hooks';

export const useSlowUpdate = (value, when = () => false, timeout = 0) => {
  const [state, setState] = React.useState(value);
  const isFirstRender = useOnFirstRender();

  React.useEffect(() => {
    if (isFirstRender) return;

    if (timeout > 0 && when()) {
      const handle = setTimeout(() => setState(value), timeout);
      return () => clearTimeout(handle);
    } else {
      setState(value);
    }
  }, [value]);

  return state;
};
